import { render, staticRenderFns } from "./QA.vue?vue&type=template&id=5a0df942&scoped=true"
import script from "./QA.vue?vue&type=script&lang=js"
export * from "./QA.vue?vue&type=script&lang=js"
import style0 from "./QA.vue?vue&type=style&index=0&id=5a0df942&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0df942",
  null
  
)

export default component.exports